import Vue from "vue";
import Component from "vue-class-component";
import { DgButton, DgColumn, DgGridContainer, DgGridContent, DgImage, DgText } from "@dasgate/uikit";
import { RouteNames } from "@/ui/_router";
import { Iam } from "@/legacy/models/constants";
import axios from "axios";

@Component({ components: { DgText, DgButton, DgColumn, DgImage, DgGridContainer, DgGridContent } })
export default class Landing extends Vue {
  // TODO: make this hexagonal
  private async getIdTokenWithRetry({
    tenant,
    identityProvider,
    accessToken,
    maxRetries = 3,
    delayMs = 300,
  }: {
    tenant: string;
    identityProvider: string;
    accessToken: string;
    maxRetries?: number;
    delayMs?: number;
  }): Promise<string | undefined> {
    const url = `${Iam}auth/realms/${tenant}/broker/${identityProvider}/token`;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (res.data?.id_token) {
          return res.data.id_token;
        } else {
          throw new Error("No id_token in broker response");
        }
      } catch (err) {
        console.warn(`Attempt ${attempt} to fetch id_token failed`, err);
        if (attempt < maxRetries) {
          await new Promise(r => setTimeout(r, delayMs * attempt));
        } else {
          throw err;
        }
      }
    }
  }

  async onContinue() {
    const identityProvider = this.$appStore.getters.settings.identityProvider;
    const tenant = this.$appStore.getters.settings.tenant;
    const accessToken = this.$appStore.getters.accessToken;

    let idToken: string | undefined;

    if (identityProvider) {
      try {
        idToken = await this.getIdTokenWithRetry({ tenant, identityProvider, accessToken });
      } catch (err) {
        console.error("Could not obtain idpIdToken after retries.", err);
        throw err;
      }
    }

    await this.$execute(this.$container.userUseCases.enroll.bind(null, idToken ? { id_token: idToken } : {}), {
      fallbackLocation: { name: RouteNames.MyAccreditations },
    });
  }
}
